import { useEffect, useRef } from 'react';

/**
 * A reference panel over the page, as the rules summary is: Escape or a
 * click outside closes it, and focus moves into it.
 */
export function Panel({ title, onClose, wide, children }: {
  title: string;
  onClose: () => void;
  wide?: boolean;
  children: React.ReactNode;
}) {
  const panel = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        // Opened from the rules summary, it closes alone.
        e.stopImmediatePropagation();
        onClose();
      }
    };
    // Capture, so it hears Escape before the rules summary under it.
    document.addEventListener('keydown', onKey, true);
    panel.current?.focus();
    return () => document.removeEventListener('keydown', onKey, true);
  }, [onClose]);

  return (
    <div className="help-backdrop" onClick={onClose} role="presentation">
      <div
        className={`help-panel plate${wide ? ' wide-panel' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-label={title}
        tabIndex={-1}
        ref={panel}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="hazard hazard-rule" role="presentation" />
        <div className="help-body">
          <div className="spread">
            <h3>{title}</h3>
            <button className="secondary" onClick={onClose}>Close</button>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
